export default __webpack_public_path__ + "static/step-2-ef5de178cf207eece60689144055bdf4.svg";